// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"6e47ccaf","368":"2e6064d1","827":"ae8c153e","977":"6e47ccaf"}[chunkId] + ".chunk.js";
};